/**
 * Initials from a display name: first character of the first word plus the
 * first character of the last word. Single-word names use one letter.
 * Matches `UserIcon` behaviour for consistency across the app.
 */
export function getNameInitials(name?: string | null): string {
  const parts = name?.trim().split(/\s+/).filter(Boolean) ?? [];
  if (parts.length === 0) {
    return '';
  }
  const first = parts[0][0] ?? '';
  const last = parts.length > 1 ? (parts[parts.length - 1][0] ?? '') : '';
  return `${first}${last}`.toUpperCase();
}
